import { useEffect, useState } from 'react'
import Slider from 'rc-slider'
import clsx from 'clsx'
import { getRangeFilterMarks } from 'src/utils/getRangeFilterMarks'
import { formatCurrency2CompactString } from 'src/utils/number/currency'
import 'rc-slider/assets/index.css'
import './styles.module.scss'
import styles from './styles.module.scss'
import Image from 'next/image'

const RangeWrapper = Slider.Range

export const LogarithmicRange = ({
  className,
  maxValue,
  value,
  action,
  isMobile = false,
  label,
}) => {
  const [range, setRange] = useState(value)

  useEffect(() => {
    setRange(value)
    action(value)
  }, [action, value])

  const logValue = [
    Number(Math.log(range[0]).toFixed(1)),
    Number(Math.log(range[1]).toFixed(1)),
  ]

  const marks = getRangeFilterMarks(maxValue, 'logarithmic', {
    [maxValue]: formatCurrency2CompactString(maxValue.toString()),
  })

  const handleChange = ([from, to]) => {
    setRange([
      Number((from === 0 ? 0 : Math.exp(from)).toFixed(0)),
      Number(Math.exp(to).toFixed(0)),
    ])
    action([
      Number((from === 0 ? 0 : Math.exp(from)).toFixed(0)),
      Number(Math.exp(to).toFixed(0)),
    ])
  }

  return (
    <div className={clsx(styles.rangeFilter, className)}>
      {isMobile && label && <div className={styles.label}>{label}</div>}
      <div className={clsx(styles.slider, { [styles.mobile]: isMobile })}>
        <div className={styles.labelContainer}>
          {label && <label>{label}</label>}
          <output className={styles.output}>
            {`${formatCurrency2CompactString(
              range[0]
            )} - ${formatCurrency2CompactString(range[1])}`}
          </output>
          <div
            className={styles.resetButton}
            onClick={() => {
              setRange([1, maxValue])
              action([1, maxValue])
            }}
          >
            <Image
              src='/assets/icons/icon-reset-filter.svg'
              width={20}
              height={20}
              alt='Reset'
            />
          </div>
        </div>
        <RangeWrapper
          step={0.000001}
          marks={marks}
          min={0}
          max={Math.log(maxValue)}
          value={logValue}
          onChange={handleChange}
          className={styles.rcSlider}
        />
      </div>
      <div className={styles.valuesContainer}>
        <span>{formatCurrency2CompactString(range[0])}</span>
        <span>{formatCurrency2CompactString(range[1])}</span>
      </div>
    </div>
  )
}
